import { useCallback, useState } from "react";
import { FormattedMessage } from "react-intl";

import preselections from "./preselections.json";
import InputItem from "../../../../app/generic/form/inputItem";
import SelectItem from "../../../../app/generic/form/selectItem";
import { getPhoneNumberPattern } from "../../../../../modules/dataFunctions";
import SelectItemWithLoad from "../../../../app/generic/form/selectItemWithLoad";

import "./index.css";

export const CzechPreselection = "+420";

const Phone = ({
  form,
  label,
  message,
  optional,
  required,
  disabled,
  phoneError,
  onlyMobile,
  onPhoneBlur,
  inputId = "",
  initialPreselection,
  disabledPreselection,
  onPreselectionSelect,
}) => {
  const [numberPattern, setNumberPattern] = useState(
    getPhoneNumberPattern(
      (initialPreselection &&
        preselections.find((p) => p.code === initialPreselection)) ||
        "CZ",
      onlyMobile
    )
  );
  const [selectedPreselection, setSelectedPreselection] = useState();
  const handlePreselectionSelect = useCallback(
    (value) => {
      const preselection = preselections.find((c) => c.code === value);
      setSelectedPreselection(preselection);
      setNumberPattern(getPhoneNumberPattern(preselection.country), onlyMobile);
      onPreselectionSelect && onPreselectionSelect(preselection);
      form && form.validateFields([`contactPhone${inputId}`]);
    },
    [form, inputId, onlyMobile, onPreselectionSelect]
  );

  const handlePhoneChange = useCallback(
    (e) =>
      e.target.value
        .replace(new RegExp(" ", "g"), "")
        .replace(`${selectedPreselection && selectedPreselection.code}`, "")
        .replace(
          `00${selectedPreselection && selectedPreselection.code.substring(1)}`,
          ""
        ),
    [selectedPreselection]
  );

  return (
    <SelectItemWithLoad
      icon
      options={preselections}
      errorMessage={
        <FormattedMessage
          id="address.preselection.loadError"
          defaultMessage="Při načítání předvoleb nastala chyba!"
        />
      }
    >
      <InputItem
        allowClear
        autoComplete="tel"
        error={phoneError}
        optional={optional}
        required={required}
        disabled={disabled}
        onBlur={onPhoneBlur}
        pattern={numberPattern}
        onValueChange={handlePhoneChange}
        fieldName={`contactPhone${inputId}`}
        label={
          label || (
            <FormattedMessage
              id="address.contactPhone"
              defaultMessage="Telefon"
            />
          )
        }
        message={
          message || (
            <FormattedMessage
              id="address.contactPhone.empty"
              defaultMessage="Zadejte prosím telefonní kontakt!"
            />
          )
        }
        addonBefore={
          <SelectItem
            useCode
            noStyle
            allowClear={false}
            options={preselections}
            onSelect={handlePreselectionSelect}
            className="address-preselection-select"
            disabled={disabledPreselection || disabled}
            fieldName={`contactPhonePreselection${inputId}`}
          />
        }
      />
    </SelectItemWithLoad>
  );
};

export default Phone;
